module.exports = __webpack_public_path__ + "static/fonts/Roboto-Thin.7500519.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.woff
// module id = 323
// module chunks = 1